const capitalize = (str) => {
  return str
    .split(/\s/gm)
    .map((s) => `${s.charAt(0).toUpperCase()}${s.slice(1)}`)
    .join(' ')
}

export default capitalize
